import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from '@ag2-weathermaker/shared/environments/environment';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';

let enableSentry = true;
if (environment.sentryEnv === 'local') {
  enableSentry = false;
}

Sentry.init({
  dsn: 'https://773fec7b76ceae8e3e90e8aac110de36@o4507181837189120.ingest.us.sentry.io/4510552220696576',
  environment: environment.sentryEnv,
  enabled: enableSentry,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 0.01, // 1% of transactions will be sent to Sentry
  tracePropagationTargets: ['localhost', environment.apiUrl],
});

bootstrapApplication(AppComponent, {
  ...appConfig,
}).catch((err) => console.error(err));
